import { useApiGet } from 'mf_core/query';
import { useMutation } from '@tanstack/react-query';

export function useExtendedSummaryMutation() {
  const apiGet = useApiGet<ProductSummaryResponse>();

  return useMutation({
    mutationFn: (skulist: string) => {
      const data = apiGet(
        `/exp-looker/v1/insights/validateproducts?q={'productIdentifiers':${skulist}, 'webonly': true,'vendorAuthorization': true}`
      );

      return data;
    },
  });
}

export interface Indicators {
  hasacopquantitybreak: boolean;
  hasacopspecialprice: boolean;
  hasacopwebdiscount: boolean;
  hasbundle: boolean;
  hascrosssell: boolean;
  hasreturnlimits: boolean;
  hasshipalong: boolean;
  hasspecialbid: boolean;
  hasstdquantitybreak: boolean;
  hasstdspecialprice: boolean;
  hasstdwebdiscount: boolean;
  hasstock: boolean;
  hasstockororder: boolean;
  haswarranty: boolean;
  iniSwitch: string;
  isBackOrderAllowed: boolean;
  isComponent: boolean;
  isNoReturnsAllowed: boolean;
  isNonTransactional: boolean;
  isNotOrderableOnline: boolean;
  isShippedFromPartner: boolean;
  isblowout: boolean;
  isclearanceproduct: boolean;
  iscustownproduct: boolean;
  isdigitaltype: boolean;
  isdirectship: boolean;
  isdirectshiporderable: boolean;
  isdiscontinued: boolean;
  isdownloadable: boolean;
  isenduserrequired: boolean;
  isexportabletocountry: boolean;
  isheavyweight: boolean;
  ishptopconfigproduct: boolean;
  islicenseproduct: boolean;
  islremodel: boolean;
  isltl: boolean;
  isoversizeproduct: boolean;
  ispreorderproduct: boolean;
  isrefurbished: boolean;
  isreplacementproduct: boolean;
  iswarranty: boolean;
  newproduct: boolean;
  replacementtype: string;
  skutype: string;
}

export interface Images {
  imageurl: string;
}

export interface Extrafee {
  feeamount: number;
  feename: string;
}

export interface Pna {
  availablequantity: number;
  currency: string;
  dealerprice: number;
  extrafee: Extrafee;
  msrp: number;
}

export interface CampaignInfo {
  promotioncode: string;
  promotionpoints: string;
  promotiontype: string;
}

export interface FreeItem {
  expiredt: string;
  freeMaterial: string;
  freeqty: string;
  image: string;
  minqty: string;
  partdescription: string;
  upcEan: string;
  vpn: string;
}

export interface CiscoFields {
  configurationindicator: string;
  globallistprice: string;
  internalbusinessentity: string;
  itemcatalogcategory: string;
  itemtype: string;
  productsubgroup: string;
  serviceprogramname: string;
}

export type ProductSummary = {
  authorizedToPurchase: boolean;
  basecost: string;
  brand: string;
  bundleSkus: string[];
  campaign: CampaignInfo;
  category: string;
  categoryrankfactor: number;
  ciscoFields: CiscoFields;
  classCode: string;
  cmpFields: string;
  cpucd: string;
  customerpartnumber: string;
  digitalsku: string;
  directShipVendorCode: number;
  directshipvendorcodes: string;
  displaypartnumber: string;
  exManufacturerpartnumber: string;
  fiscalclass: string;
  freeItem: FreeItem;
  globalpartnumber: string;
  globalproducthierarchy: string;
  harmonizedCode: string;
  images: Images;
  incurrencycode: string;
  indicators: Indicators;
  isSapCountry: boolean;
  keywords: string;
  languagecode: string;
  layout: string;
  longdescription: string;
  manufacturerdescription: string;
  manufacturerpartnumber: string;
  materialtype: string;
  outcurrencycode: string;
  partOfBunddles: string[];
  partnumber: string;
  pna: Pna;
  productfamily: string;
  productmodel: string;
  producttype: string;
  restrictionCode: string;
  salesRank: string;
  score: number;
  scoringfactor: string;
  shortdescription: string;
  similarProducts: string[];
  stockStatus: string;
  subMaterial: string;
  subcategory: string;
  suggestedmaterial: string;
  thirdpartydescription: string;
  upcean: string;
  vendorCode: string;
  vendorSubRange: string;
};

export type TotalField = {
  count: string;
  relation: string;
};

export type ProductSummaryResponse = {
  isSuccess: boolean;
  summaries: ProductSummary[];
  total: TotalField;
};
